import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { PAMachineDowntime } from "./types";

export const paMachineDowntimeListService = (params: {
  page?: number;
  limit?: number;
  status?: number;
  startDate?: string;
  endDate?: string;
  empCodes?: string[];
  empIds?: number[];
  transactionType?: string;
  workShiftCodes?: string[];
  machineIds?: string[];
  machineGroupIds?: string[];
  machineGroupCodes?: string[];
  productIds?: string[];
  statusApprove?: boolean;
  productCodes?: string[];
}) =>
  RestAPIClient.call<RestAPIResponseList<PAMachineDowntime>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paMachineDowntimeImportService = (params: {
  startDate: string;
  endDate: string;
  items: {
    date: string;
    workShiftCode: string;
    timeIn: string;
    timeOut: string;
    fromTime: string;
    toTime: string;
    totalHours: number;
    transactionType: string;
    machineGroupCode: string;
    machineCode: string;
    productCode: string;
    productUnit: string;
    empCode: string;
    reasonCode: string;
    syncId: null;
  }[];
  empCodes: string[];
  workShiftCodes: string[];
  productCodes: string[];
  machineCodes: string[];
  machineGroupCodes: string[];
  reasonCodes: string[];
}) =>
  RestAPIClient.call<PAMachineDowntime>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const paMachineDowntimeSyncService = (params: {
  fromDate: string;
  toDate: string;
}) =>
  RestAPIClient.call<PAMachineDowntime>({
    method: HTTPRequestMethods.POST,
    url: Paths.Sync,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
